import request from "utils/request";
import requestJWT from "utils/requestJWT";

const getAllApi = async () => {
    return await request.get(`/tour-type/`);
};

const getByTourTypeSlugApi = async (slug, query, min, max, sort, page, perPage, person) => {
    return await request.get(`/tour/tour-type/${slug}?query=${query}&min=${min}&max=${max}&sort=${sort}&page=${page}&item=${perPage}&person=${person}`);
};


const getAllAndFilterTourTypeApi = async (query, page) => {
    return await request.get(`/tour-type/get-all?query=${query}&page=${page}&item=5`);
};

const createTourTypeApi = async (data) => {
    return await requestJWT.post(`/tour-type/create`, data);
};

const updateTourTypeApi = async (id, data) => {
    return await requestJWT.put(`/tour-type/${id}/update`, data);
};

const removeTourTypeApi = async (id) => {
    return await requestJWT.delete(`/tour-type/${id}/remove`);
};

export {
    getAllApi,
    getAllAndFilterTourTypeApi,
    createTourTypeApi,
    updateTourTypeApi,
    removeTourTypeApi,
    getByTourTypeSlugApi
};
